import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Grid,
  Typography,
} from '@material-ui/core';
import {
  NavigateBeforeOutlined as BackIcon,
} from '@material-ui/icons';
import {
  MyPATDialog,
  SearchField,
} from '../../common';

import ContentPagination from '../../mylibrary/components/ContentPagination';
import ContentCard from '../../user-profile/components/ContentCard';

import ContentData from '../../mylibrary/types/ContentData';
import { MiniLibraryBody } from '../types/MiniLibraryBody';

const styles = (theme: Theme) => createStyles({
  cursorPointer: {
    cursor: 'pointer',
  },
  mb1x: {
    marginBottom: theme.spacing.unit,
  },

  dialogTitle: {
    marginLeft: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
    textTransform: 'capitalize',
    borderLeft: `1px solid ${theme.palette.grey[400]}`,
  },
  backIconRoot: {
    fill: theme.palette.text.secondary,
    fontSize: 24,
    opacity: 0.5,
    marginBottom: 3
  },

  searchField: {
    backgroundColor: theme.palette.common.white,
    padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
  }
});

interface ViewMiniLibraryDialogProps extends WithStyles<typeof styles> {
  dialogOpen: boolean,
  dialogCloseHandler: () => void,
  dialogData: {
    libName: string,
    libId: string,
  },
  history: any,
  miniLibraryList: MiniLibraryBody[],
}

interface ViewMiniLibraryDialogState {
  searchValue: string,
  currentPage: number,
}

class ViewMiniLibraryDialog extends Component<ViewMiniLibraryDialogProps, ViewMiniLibraryDialogState> {
  constructor(props: ViewMiniLibraryDialogProps) {
    super(props);
    this.state = {
      searchValue: '',
      currentPage: 1,
    }

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handleSearchChange = (evt: any) => this.setState({ searchValue: evt.target.value });

  handlePageChange = (evt: any, page: any) => this.setState({ currentPage: page, searchValue: '' });

  getViewLibData = () => {
    const lib: any = _.find(this.props.miniLibraryList, ['_id', this.props.dialogData.libId]);
    let viewLibData: any[] = [];

    if (lib['isDataUpdated']) {
      for (let type in lib.contentMapped) {
        lib.contentMapped[type].map((content: any) => {
          viewLibData.push(content);
        })
      }
    }

    return viewLibData;
  }

  render() {
    const {
      classes,
      dialogOpen,
      dialogCloseHandler,
      dialogData,
      history,
    } = this.props;

    const {
      searchValue,
      currentPage,
    } = this.state;

    const viewLibData: ContentData[] = this.getViewLibData();
    const prevPage = this.state.currentPage - 1;
    const paginatedViewLibData = viewLibData.slice(prevPage * 20, this.state.currentPage * 20);

    return (
      <MyPATDialog
        dialogOpen={dialogOpen}
        otherDialogProps={{ fullScreen: true }}
        customDialogTitle={
          <Grid container justify="space-between" alignItems="center">
            <Grid item xs="auto">
              <Typography
                color="textPrimary"
                variant="body1"
                className={classes.cursorPointer}
                onClick={dialogCloseHandler}
              >
                <BackIcon classes={{ root: classes.backIconRoot }} />
                <strong>Back to Mini Library</strong>
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography
                noWrap
                variant="h6"
                className={classes.dialogTitle}
              >
                {_.get(dialogData, 'libName', '')}
              </Typography>
            </Grid>
          </Grid>
        }
      >
        <Grid container justify="center">
          <Grid item xs={12} sm={11} md={10}>
            <Grid container alignItems="center" justify="space-between" className={classes.mb1x}>
              <Grid item xs="auto" className={classes.mb1x}>
                <SearchField
                  placeholder="Search Content"
                  className={classes.searchField}
                  value={searchValue}
                  onChange={this.handleSearchChange.bind(this)}
                />
              </Grid>
              <Grid item xs="auto" className={classes.mb1x}>
                <ContentPagination
                  page={currentPage}
                  count={viewLibData.length || 0}
                  rowsPerPage={20}
                  onChangePage={this.handlePageChange.bind(this)}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center">
              {_.map(paginatedViewLibData, (cardInfo: ContentData, index: number) =>
                _.includes(_.toLower(cardInfo.title), _.toLower(searchValue)) && (
                  <Grid key={index} item xs={12} className={classes.mb1x}>
                    <ContentCard cardInfo={cardInfo} history={history} />
                  </Grid>
                )
              )}
            </Grid>
          </Grid>
        </Grid>
      </MyPATDialog>
    )
  }
}

const mapStateToProps = (state: any) => ({
  miniLibraryList: _.get(state, 'userManagement.miniLibrary.list', []),
})

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(ViewMiniLibraryDialog));